"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMeasureFilterFromConditionFilterJaql = exports.createAttributeFilterFromConditionFilterJaql = exports.getSelectedConditionOption = void 0;
const types_js_1 = require("./types.js");
const filter_code_util_js_1 = require("./filter-code-util.js");
const filterFactory = __importStar(require("../factory.js"));
const attribute_measure_util_js_1 = require("./attribute-measure-util.js");
const translatable_error_js_1 = require("../../../translation/translatable-error.js");
const filter_config_utils_js_1 = require("../filter-config-utils.js");
const isTopCondition = (filter) => filter.top !== undefined;
const isBottomCondition = (filter) => filter.bottom !== undefined;
const isExcludeCondition = (filter) => { var _a; return !!((_a = filter.exclude) === null || _a === void 0 ? void 0 : _a.members); };
const isMembersCondition = (filter) => !!filter.members && !!filter.isCondition;
const isWithinCondition = (filter) => { var _a, _b; return ((_a = filter.last) === null || _a === void 0 ? void 0 : _a.anchor) !== undefined || ((_b = filter.next) === null || _b === void 0 ? void 0 : _b.anchor) !== undefined; };
const isGreaterThanCondition = (filter) => filter.fromNotEqual !== undefined;
const isGreaterThanOrEqualCondition = (filter) => filter.from !== undefined && !filter.isBetween;
const isLessThanCondition = (filter) => filter.toNotEqual !== undefined;
const isLessThanOrEqualCondition = (filter) => filter.to !== undefined && !filter.isBetween;
const isEqualsCondition = (filter) => filter.equals !== undefined;
const isNotEqualCondition = (filter) => filter.doesntEqual !== undefined;
const isEmptyCondition = (filter) => !!(filter.equals === '' && filter.isEmpty);
const isNotEmptyCondition = (filter) => !!(filter.doesntEqual === '' && filter.isEmpty);
const isContainsCondition = (filter) => filter.contains !== undefined;
const isDoesntContainCondition = (filter) => filter.doesntContain !== undefined;
const isStartsWithCondition = (filter) => filter.startsWith !== undefined;
const isDoesntStartsWithCondition = (filter) => filter.doesntStartWith !== undefined;
const isEndsWithCondition = (filter) => filter.endsWith !== undefined;
const isDoesntEndWithCondition = (filter) => filter.doesntEndWith !== undefined;
const isBetweenCondition = (filter) => filter.from !== undefined && filter.to !== undefined;
const isNotBetweenCondition = (filter) => { var _a, _b; return ((_a = filter.exclude) === null || _a === void 0 ? void 0 : _a.from) !== undefined && ((_b = filter.exclude) === null || _b === void 0 ? void 0 : _b.to) !== undefined; };
const isMultipleCondition = (filter) => !!(filter.or || filter.and);
const getSelectedConditionOption = (filter) => {
    if (isBottomCondition(filter))
        return types_js_1.ConditionFilterType.BOTTOM;
    if (isTopCondition(filter))
        return types_js_1.ConditionFilterType.TOP;
    if (isExcludeCondition(filter))
        return types_js_1.ConditionFilterType.IS_NOT;
    if (isWithinCondition(filter))
        return types_js_1.ConditionFilterType.IS_WITHIN;
    if (isGreaterThanCondition(filter))
        return types_js_1.ConditionFilterType.GREATER_THAN;
    if (isLessThanCondition(filter))
        return types_js_1.ConditionFilterType.LESS_THAN;
    if (isEqualsCondition(filter))
        return types_js_1.ConditionFilterType.EQUALS;
    if (isNotEqualCondition(filter))
        return types_js_1.ConditionFilterType.DOESNT_EQUAL;
    if (isEmptyCondition(filter))
        return types_js_1.ConditionFilterType.IS_EMPTY;
    if (isNotEmptyCondition(filter))
        return types_js_1.ConditionFilterType.IS_NOT_EMPTY;
    if (isContainsCondition(filter))
        return types_js_1.ConditionFilterType.CONTAINS;
    if (isDoesntContainCondition(filter))
        return types_js_1.ConditionFilterType.DOESNT_CONTAIN;
    if (isDoesntEndWithCondition(filter))
        return types_js_1.ConditionFilterType.DOESNT_END_WITH;
    if (isDoesntStartsWithCondition(filter))
        return types_js_1.ConditionFilterType.DOESNT_START_WITH;
    if (isEndsWithCondition(filter))
        return types_js_1.ConditionFilterType.ENDS_WITH;
    if (isStartsWithCondition(filter))
        return types_js_1.ConditionFilterType.STARTS_WITH;
    if (isNotBetweenCondition(filter))
        return types_js_1.ConditionFilterType.IS_NOT_BETWEEN;
    if (isMembersCondition(filter))
        return types_js_1.ConditionFilterType.IS;
    if (isMultipleCondition(filter))
        return types_js_1.ConditionFilterType.MULTIPLE_CONDITION;
    // Need to verify BETWEEN case before the GREATER_THAN_OR_EQUAL and LESS_THAN_OR_EQUAL due to missing `filter.isBetween` property in some cases
    if (isBetweenCondition(filter))
        return types_js_1.ConditionFilterType.BETWEEN;
    if (isGreaterThanOrEqualCondition(filter))
        return types_js_1.ConditionFilterType.GREATER_THAN_OR_EQUAL;
    if (isLessThanOrEqualCondition(filter))
        return types_js_1.ConditionFilterType.LESS_THAN_OR_EQUAL;
    return types_js_1.ConditionFilterType.NONE;
};
exports.getSelectedConditionOption = getSelectedConditionOption;
/**
 * Creates an attribute filter from the provided attribute and condition filter JAQL object
 *
 * @param attribute - Provided attribute
 * @param conditionFilterJaql - Condition filter JAQL object
 * @param guid - GUID for the filter
 * @returns attribute filter
 */
const createAttributeFilterFromConditionFilterJaql = (attribute, conditionFilterJaql, guid) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const conditionType = (0, exports.getSelectedConditionOption)(conditionFilterJaql);
    switch (conditionType) {
        case types_js_1.ConditionFilterType.BOTTOM:
            if (conditionFilterJaql.by) {
                return (0, filter_code_util_js_1.withComposeCode)(filterFactory.bottomRanking, 'bottomRanking')(attribute, (0, attribute_measure_util_js_1.createMeasureFromRankingFilterJaql)(conditionFilterJaql.by, conditionFilterJaql.rankingMessage), conditionFilterJaql[types_js_1.ConditionFilterType.BOTTOM], { guid });
            }
            break;
        case types_js_1.ConditionFilterType.EQUALS:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.equals, 'equals')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.EQUALS], { guid });
        case types_js_1.ConditionFilterType.DOESNT_EQUAL:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.doesntEqual, 'doesntEqual')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.DOESNT_EQUAL], { guid });
        case types_js_1.ConditionFilterType.GREATER_THAN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.greaterThan, 'greaterThan')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.GREATER_THAN], { guid });
        case types_js_1.ConditionFilterType.GREATER_THAN_OR_EQUAL:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.greaterThanOrEqual, 'greaterThanOrEqual')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.GREATER_THAN_OR_EQUAL], { guid });
        case types_js_1.ConditionFilterType.TOP:
            if (conditionFilterJaql.by) {
                return (0, filter_code_util_js_1.withComposeCode)(filterFactory.topRanking, 'topRanking')(attribute, (0, attribute_measure_util_js_1.createMeasureFromRankingFilterJaql)(conditionFilterJaql.by, conditionFilterJaql.rankingMessage), conditionFilterJaql[types_js_1.ConditionFilterType.TOP], { guid });
            }
            break;
        case types_js_1.ConditionFilterType.STARTS_WITH:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.startsWith, 'startsWith')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.STARTS_WITH], { guid });
        case types_js_1.ConditionFilterType.DOESNT_START_WITH:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.doesntStartWith, 'doesntStartWith')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.DOESNT_START_WITH], { guid });
        case types_js_1.ConditionFilterType.ENDS_WITH:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.endsWith, 'endsWith')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.ENDS_WITH], { guid });
        case types_js_1.ConditionFilterType.DOESNT_END_WITH:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.doesntEndWith, 'doesntEndWith')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.DOESNT_END_WITH], { guid });
        case types_js_1.ConditionFilterType.CONTAINS:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.contains, 'contains')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.CONTAINS], { guid });
        case types_js_1.ConditionFilterType.DOESNT_CONTAIN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.doesntContain, 'doesntContain')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.DOESNT_CONTAIN], { guid });
        case types_js_1.ConditionFilterType.LESS_THAN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.lessThan, 'lessThan')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.LESS_THAN], { guid });
        case types_js_1.ConditionFilterType.LESS_THAN_OR_EQUAL:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.lessThanOrEqual, 'lessThanOrEqual')(attribute, conditionFilterJaql[types_js_1.ConditionFilterType.LESS_THAN_OR_EQUAL], { guid });
        case types_js_1.ConditionFilterType.BETWEEN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.between, 'between')(attribute, conditionFilterJaql.from, conditionFilterJaql.to, { guid });
        case types_js_1.ConditionFilterType.IS_NOT_BETWEEN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.exclude, 'exclude')((0, filter_code_util_js_1.withComposeCode)(filterFactory.between, 'between')(attribute, (_a = conditionFilterJaql.exclude) === null || _a === void 0 ? void 0 : _a.from, (_b = conditionFilterJaql.exclude) === null || _b === void 0 ? void 0 : _b.to, { guid }), undefined, { guid });
        case types_js_1.ConditionFilterType.MULTIPLE_CONDITION:
            if (conditionFilterJaql.and) {
                return (0, filter_code_util_js_1.withComposeCode)(filterFactory.intersection, 'intersection')(conditionFilterJaql.and.map((c) => (0, exports.createAttributeFilterFromConditionFilterJaql)(attribute, c, guid)), { guid });
            }
            if (conditionFilterJaql.or) {
                return (0, filter_code_util_js_1.withComposeCode)(filterFactory.union, 'union')(conditionFilterJaql.or.map((c) => (0, exports.createAttributeFilterFromConditionFilterJaql)(attribute, c, guid)), { guid });
            }
            break;
        case types_js_1.ConditionFilterType.IS_NOT: {
            const deactivatedMembers = (((_c = conditionFilterJaql.filter) === null || _c === void 0 ? void 0 : _c.turnedOff) && ((_d = conditionFilterJaql.filter.exclude) === null || _d === void 0 ? void 0 : _d.members)) ||
                [];
            const selectedMembers = ((_f = (_e = conditionFilterJaql.exclude) === null || _e === void 0 ? void 0 : _e.members) === null || _f === void 0 ? void 0 : _f.filter((member) => !deactivatedMembers.includes(member))) || [];
            // use members filter with exclude instead of exclude filter
            const config = (0, filter_config_utils_js_1.simplifyFilterConfig)({
                guid,
                excludeMembers: true,
                enableMultiSelection: (_g = conditionFilterJaql.multiSelection) !== null && _g !== void 0 ? _g : true,
                deactivatedMembers,
            });
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.members, 'members')(attribute, selectedMembers, config);
        }
        case types_js_1.ConditionFilterType.AFTER:
        case types_js_1.ConditionFilterType.BEFORE:
        case types_js_1.ConditionFilterType.IS_EMPTY:
        case types_js_1.ConditionFilterType.IS_NOT_EMPTY:
            // TODO Handle these cases later; may need filterFactory function added first
            break;
    }
    throw new translatable_error_js_1.TranslatableError('errors.filter.unsupportedConditionFilter', {
        filter: JSON.stringify(conditionFilterJaql),
    });
};
exports.createAttributeFilterFromConditionFilterJaql = createAttributeFilterFromConditionFilterJaql;
/**
 * Creates a measure filter from the provided measure and condition filter JAQL object
 *
 * @param measure - Provided measure
 * @param conditionFilterJaql - Condition filter JAQL object
 * @param guid - GUID for the filter
 * @returns measure filter
 */
const createMeasureFilterFromConditionFilterJaql = (measure, conditionFilterJaql, guid) => {
    const conditionType = (0, exports.getSelectedConditionOption)(conditionFilterJaql);
    switch (conditionType) {
        case types_js_1.ConditionFilterType.EQUALS:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureEquals, 'measureEquals')(measure, conditionFilterJaql[types_js_1.ConditionFilterType.EQUALS], { guid });
        case types_js_1.ConditionFilterType.GREATER_THAN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureGreaterThan, 'measureGreaterThan')(measure, conditionFilterJaql[types_js_1.ConditionFilterType.GREATER_THAN], { guid });
        case types_js_1.ConditionFilterType.GREATER_THAN_OR_EQUAL:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureGreaterThanOrEqual, 'measureGreaterThanOrEqual')(measure, conditionFilterJaql[types_js_1.ConditionFilterType.GREATER_THAN_OR_EQUAL], { guid });
        case types_js_1.ConditionFilterType.LESS_THAN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureLessThan, 'measureLessThan')(measure, conditionFilterJaql[types_js_1.ConditionFilterType.LESS_THAN], { guid });
        case types_js_1.ConditionFilterType.LESS_THAN_OR_EQUAL:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureLessThanOrEqual, 'measureLessThanOrEqual')(measure, conditionFilterJaql[types_js_1.ConditionFilterType.LESS_THAN_OR_EQUAL], { guid });
        case types_js_1.ConditionFilterType.BETWEEN:
            return (0, filter_code_util_js_1.withComposeCode)(filterFactory.measureBetween, 'measureBetween')(measure, conditionFilterJaql.from, conditionFilterJaql.to, { guid });
    }
    throw new translatable_error_js_1.TranslatableError('errors.filter.unsupportedConditionFilter', {
        filter: JSON.stringify(conditionFilterJaql),
    });
};
exports.createMeasureFilterFromConditionFilterJaql = createMeasureFilterFromConditionFilterJaql;
